export const getAgentHubAffiliationOptions = (
  region: string,
): Array<App.AgentHubAUAgencyAffiliations | App.AgentHubNZAgencyAffiliations | App.AgentHubUSAgencyAffiliations> => {
  if (region === 'NZ') return AGENT_HUB_NZ_AFFILIATION_OPTIONS
  if (region === 'US') return AGENT_HUB_US_AFFILIATION_OPTIONS
  return AGENT_HUB_AU_AFFILIATION_OPTIONS
}

export const AGENT_HUB_AU_AFFILIATION_OPTIONS: Array<App.AgentHubAUAgencyAffiliations> = [
  '1000 Mile Travel Group',
  'ATAC',
  'CT Partners',
  'Express Travel Group',
  'FBI Travel',
  'FC Independent',
  'Flight Centre Brand',
  'Flight Centre Business Travel',
  'Goldman Travel Corporation',
  'Helloworld',
  'Helloworld Associate',
  'Helloworld Branded',
  'Helloworld Business Travel',
  'House of Travel',
  'Independent (no affiliation)',
  'Independent Travel Group (part of ETG)',
  'italktravel & cruise',
  'itravel Australia Group',
  'Link',
  'Magellan Travel Group',
  'MTA Travel',
  'My Travel Group',
  'Platinum Travel Management',
  'Pulse Travel',
  'RAA',
  'Savenio',
  'Select Travel Service',
  'Smartflyer Australia Pty Ltd',
  'Travel Associates',
  'Travel at 60',
  'Travel Partners',
  'Travellers Choice Limited',
  'TravelManagers Australia',
  'Other (please specify)',
]
export const AGENT_HUB_NZ_AFFILIATION_OPTIONS: Array<App.AgentHubNZAgencyAffiliations> = [
  'Accent on Travel',
  'Aspire Travel Group',
  'APX Travel Management',
  'BonVoyage Cruises & Travel',
  'China Travel Service',
  'Excel Travel',
  'Express Travel Group',
  'First Travel Group',
  'Flight Centre NZ',
  'Helloworld NZ',
  'House of Travel',
  'Independent no Affiliation',
  'Mondo Travel',
  'Orbit Travel',
  'Our Vacation Centre',
  'Our World',
  'Planet Earth Travel',
  'Quay Travel',
  'Travel Associates NZ',
  'Travel Managers NZ',
  'World Travellers',
  'Worldwide Holidays',
  'You Travel and Cruise',
]

export const AGENT_HUB_US_AFFILIATION_OPTIONS: Array<App.AgentHubUSAgencyAffiliations> = [
  '1000 Mile Travel',
  'AAA',
  'ACTA',
  'Affluent Traveler Collection',
  'American Express Travel',
  'Andova Travel',
  'Avoya Travel',
  'ASAP Tickets',
  'Carlson Wagonlit Travel',
  'Coastline Travel Group',
  'Cruise Holidays',
  'Cruise Planners',
  'CruiseOne',
  'Dream Vacations',
  'Dugans Travels',
  'Ensemble Travel Group',
  'Envoyage',
  'ERA of Travel',
  'Fora',
  'Geringer Global',
  'Gifted Travel Network',
  'Global Services',
  'Hickory',
  'ICT - Incentive Connection Travel',
  'Independent by Flight Centre',
  'Internova Travel Group',
  'KHM Travel Group',
  'Leisure Travel Alliance',
  'Liberty Travel',
  'MAST Travel Network',
  'Nest',
  'Nexion',
  'Oasis Travel Network',
  'ONVIGO',
  'Opulance',
  'Outside Agents',
  'Ovation',
  'Provident',
  'Signature',
  'Travel Experts',
  'Travel Leaders Group',
  'Travelmation',
  'Travel Savers',
  'Virtuoso',
  'WESTA',
  'Independent no affiliation',
  'A Plus Travel Adventures',
  'A Ticket To Travel',
  'AAA Club Alliance',
  'AAA Independent Travel Agency',
  'AAA Western and Central New York',
  'ABT - US Travel',
  'Academy Travel Inc.',
  'Accent on Travel',
  'Accent Travel Int`l',
  'Acendas Travel',
  'Ahoy Vacations',
  'Alaska Travel Source',
  'All About Romance Travel',
  'All Travel & Cruise Center, Inc.',
  'All Travel Company, Inc.',
  'Alpha Voyages Inc',
  'American Discount Cruises & Travel',
  'Andavo Travel',
  'ATHome',
  'Atlantic Pacific Travel',
  'Atlas Tour and Travel',
  'Avenue Two Travel',
  'Avoya Travel®',
  'Bayu Buana Travel',
  'Betty Barnes Travel',
  'BNT TRAVEL GROUP',
  'Brennco',
  'Brentwood Travel Services',
  'Bridges & Holman Worldwide Travel',
  'Brownell Travel',
  'CADENCE',
  'Carlisle Travel',
  'Centre Holidays',
  'Classic World Travel',
  'Clearwater Cruises Tours & Groups',
  'Coasters & Castles Travel, LLC',
  'Conference and Travel',
  'Cordially Yours Travel',
  'Cruise & Travel Experts',
  'Cruise Brothers - Cruising Free',
  'Cruise Travel Outlet',
  'Cruise.com Host Agency Division',
  'CruiseDirect.com',
  'Cruises International / Vacations Land and Sea',
  'Cruises, Inc.',
  'Cruises-N-More',
  'CWT Vacations',
  'Davcar Travel Experts Host Agency',
  'Davisville Travel',
  'Deannas Travel, LLC',
  'Destination Wedding Travel, Inc',
  'Destinations 24/7 Travel Services',
  'Destiny Travel Network',
  'Distinctive Travel',
  'DWB Vacations',
  'El Sol Travel',
  'eTravel Unlimited, LLC',
  'Expedia Cruise Ship Centers OVC',
  'Expedia Cruises',
  'Expedia CruiseShipCenters Burnaby, B.C.',
  'Family Fun Cruises & Tours Inc.',
  'Famvia Travel',
  'First Travel Alliance',
  'FROSCH Travel',
  'Gateway Travel',
  'Gateway Travels and Cruises Inc.',
  'Genie Travel',
  'Global Travel',
  'Greenwood Cruise and Travel LLC',
  'Groupit Travel Host Agency',
  'Gulliver`s Travel Service, Inc.',
  'Habitats by Kat',
  'Honey Bee Travel Agency',
  'Horizons AAA Travel Independent Contractor Program',
  'Independent By Flight Centre',
  'Independent by Liberty Travel',
  'Integrated Travel Solutions (ITS)',
  'Jess Travel',
  'Journeys Travel Inc',
  'Kemp Travel Group',
  'Kings Crossing Travel',
  'Kvi Travel',
  'L & M Travel',
  'Lake Shore Travel',
  'Legato Travel Solutions',
  'LEVARTE TRAVEL',
  'Life is Better Traveling',
  'LTA Central',
  'LUXE Travel',
  'Luxevo Vacations',
  'M & J Travel Services, LLC',
  'M & M Travel and Tours, LLC.',
  'Magical Hosts',
  'MAGICAL ISLAND TOURS AND TRAVEL LLC',
  'Magical Moments Vacations',
  'Million Miles Travel Agency, LLC',
  'Montecito Village Travel',
  'My Vacation Lady',
  'NEST Plus',
  'Nexion® Travel Group',
  'NOW Destination Weddings',
  'OAL Travel Network',
  'OASIS Travel Network',
  'Ovation Travel Group',
  'Perfect Trips Travel Agency',
  'Pickles Travel Network',
  'Platinum Journeys Travel',
  'Plaza Travel',
  'PNR Travel',
  'Prestige Agent Network',
  'Prima Travel Agents',
  'ProTIX Agent Support Network',
  'ProTravel International',
  'Romance Journeys Travel Group',
  'Romance Travel Group',
  'Sanborn`s Travel Service',
  'Select Sailings',
  'Singer Travel',
  'St. Helena Travel - Napa Valley',
  'Starship Travel Inc.',
  'Sunrise Travel Services, ULC',
  'Sunward Adventures',
  'Super Host Agency - Main Street Travel',
  'Taaj Travel Limited',
  'TerraMar Travel Inc',
  'The Best Travel Agency, LLC',
  'The Cruise Shop / Viking Travel Service',
  'The Cruiseman',
  'The Travel Agent Next Door',
  'The Travel Center / Corporate Travel',
  'The Travel Gallery, Inc.',
  'The Travel Gals',
  'The Travel Mechanic',
  'The Travel Planner, Inc.',
  'The Travel Society LLC',
  'The Travelsmiths',
  'Tier One Travel',
  'TotallyTrips',
  'Travel and Transport Vacations',
  'Travel Designers Travel Leaders',
  'TRAVEL DESTINATIONS INC.',
  'Travel Edge',
  'Travel Experts, Inc.',
  'Travel Haus',
  'Travel Leaders Market Square Travel',
  'Travel Leaders Network',
  'Travel Leaders of Lynnwood',
  'Travel Masters',
  'Travel Network',
  'Travel Network/Vacation Central',
  'Travel Planners International',
  'Travel Quest Network',
  'Travel Tours of Maryland',
  'Travel Travel',
  'Travel Troops',
  'TravelDesigns by Campbell',
  'TravelFun.Biz',
  'Travelink American Express',
  'TravelOnly',
  'TravelStore',
  'Travelwire',
  'Travelwize',
  'Trevello Travel Group',
  'Triptopia Luxury Travel Designers',
  'TTI Canada',
  'Uniglobe Travel Center',
  'US1Travel',
  'Vacation Connection / SEACruises',
  'Valerie Wilson Travel',
  'Walker Travel and Cruises',
  'Western Skies Travel',
  'World Class Travel Network',
  'World Travel Service',
  'World Travel Specialists',
  'You Deserve It! Vacations',
]

export const AGENT_HUB_DEFAULT_PHONE_NUMBER_PREFIX: Record<App.AgentHubAvailableRegions, string> = {
  AU: '+61',
  CA: '+1',
  CN: '+86',
  FR: '+33',
  DE: '+49',
  IN: '+91',
  ID: '+62',
  IE: '+353',
  IL: '+972',
  IT: '+39',
  JP: '+81',
  KR: '+82',
  MO: '+853',
  MY: '+60',
  NL: '+31',
  NZ: '+64',
  PH: '+63',
  QA: '+974',
  RU: '+7',
  SA: '+966',
  SG: '+65',
  ZA: '+27',
  ES: '+34',
  TW: '+886',
  TH: '+66',
  AE: '+971',
  GB: '+44',
  US: '+1',
  VN: '+84',
}
